import { render, staticRenderFns } from "./OwnPackagesIsps.vue?vue&type=template&id=11b1d55e&scoped=true&"
import script from "./OwnPackagesIsps.vue?vue&type=script&lang=js&"
export * from "./OwnPackagesIsps.vue?vue&type=script&lang=js&"
import style0 from "./OwnPackagesIsps.vue?vue&type=style&index=0&id=11b1d55e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b1d55e",
  null
  
)

export default component.exports